import firebase from "./FirebaseConfig";

// export const googleProvider = new firebase.auth.GoogleAuthProvider();
export const googleProvider = new firebase.auth.GoogleAuthProvider();
